import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../environments/environment';
import { ResponseModel } from '../models/api.model';
import { SanitizationService } from './sanitization.service';

@Injectable()
export class ReportingService {

  requireTimeZone = ['EST', 'EDT'];
  timeZone = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
  timeZoneFactor = (new Date().getTimezoneOffset()) / 60;
  factor = this.requireTimeZone.includes(this.timeZone) ? this.timeZoneFactor : null;

  constructor(private http: HttpClient, private sanitizationService: SanitizationService) { }

  getWeeklyReportData(startDate: any, endDate: any) {
    let params = new HttpParams();

    params = params.set('startdate', startDate);
    params = params.set('enddate', endDate);

    if (this.factor != null) {
      params = params.set('timeZoneFactor', this.factor);
    }
    else {
      params = params.set('timeZoneFactor', '');
    }

    return this.http.get(`${environment.baseUrl}api/report/getweeklyreport`, { params: params })
      .pipe(map(res => {
        if (res != null)
          return <ResponseModel<any>>res;
      }));
  }

  downloadWeeklyReportData(startDate: any, endDate: any) {
    let params = new HttpParams();

    params = params.set('startdate', startDate);
    params = params.set('enddate', endDate);

    if (this.factor != null) {
      params = params.set('timeZoneFactor', this.factor);
    }
    else {
      params = params.set('timeZoneFactor', '');
    }

    return this.http.get(`${environment.baseUrl}api/report/download_weeklyreport`, { responseType: 'blob', params: params })
      .pipe(map((res: any) => {
        let url = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'Weekly Report';
        a.click();
      }));
  }

  downloadDataPullReport(paylod: any) {
    // Note: Using 'paylod' typo to match existing code
    let sanitizedPayload = this.sanitizationService.sanitizeObject(paylod, 'text');
    sanitizedPayload.timeZoneFactor = this.factor;
    return this.http.post(`${environment.baseUrl}api/report/download_orderdatapull`, sanitizedPayload, { responseType: 'blob' })
      .pipe(map((res: any) => {
        let url = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'Data Pull Report';
        a.click();
      }));
  }

  downloadVIPRushReport(paylod: any) {
    // Note: Using 'paylod' typo to match existing code
    let sanitizedPayload = this.sanitizationService.sanitizeObject(paylod, 'text');
    sanitizedPayload.timeZoneFactor = this.factor;
    return this.http.post(`${environment.baseUrl}api/report/download_orderupdatereport`, sanitizedPayload, { responseType: 'blob' })
      .pipe(map((res: any) => {
        let url = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'Update Report.pdf';
        a.click();
      }));
  }

  downloadAccountReceivableReport() {
    let params = new HttpParams();

    if (this.factor != null) {
      params = params.set('timeZoneFactor', this.factor);
    }
    else {
      params = params.set('timeZoneFactor', '');
    }

    return this.http.get(`${environment.baseUrl}api/report/download_accountreceivablereport`, { responseType: 'blob', params: params })
      .pipe(map((res: any) => {
        let url = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'Accounts Receivable Report';
        a.click();
      }));
  }

  downloadAccountPayableReport() {
    let params = new HttpParams();

    if (this.factor != null) {
      params = params.set('timeZoneFactor', this.factor);
    }
    else {
      params = params.set('timeZoneFactor', '');
    }

    return this.http.get(`${environment.baseUrl}api/report/download_accountpayablereport`, { responseType: 'blob', params: params })
      .pipe(map((res: any) => {
        let url = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        a.href = url;
        a.download = 'Accounts Payable Report';
        a.click();
      }));
  }

  getVIPRushtData(paylod: any) {
    paylod.timeZoneFactor = this.factor;
    return this.http.post(`${environment.baseUrl}api/report/getorderupdatereport`, paylod)
      .pipe(map(res => {
        if (res != null)
          return <ResponseModel<any>>res;
      }));
  }
}
